<template>
    <div>
        <div class="form-group" style="display: flex; flex-direction: column">
            <div style="width: 50%;">
                <VueDateFilter @dateFilterChange="dateFilterApplied" />
            </div>
        </div>


        <div class="btn-group crud-form-action-btn">
            <button :disabled="isLoading" @click="fetch" type="submit" class="btn btn-success">Generate report</button>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import VueDateFilter from "../../generic/VueDateFilter";

const PER_PAGE = 10;

export default {
    name: "CreateTrafficOwnerReport",
    props: ['url'],
    components: {
    VueDateFilter,
},
    data() {
        return {
            isLoading: false,
            dateFrom: null,
            dateTo: null,
            ownerTraffic: {},
            dates: {
                start: null,
                end: null,
            },
        }
    },

    watch: {
        dateFrom(date) {
            this.$set(this.dates, 'start', moment(date).utc().unix())
        },
        dateTo(date) {
            this.$set(this.dates, 'end', moment(date).utc().unix())
        }
    },

    methods: {
        fetch() {
            const filters = this.dates;
            this.isLoading = true;
            axios.post('/traffic-owner-report-requests', filters).then((response) => {

                this.isLoading = false;
                alert(response.data.message);
                window.location.href = response.data.redirect;

                this.isLoading = false;
            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                    }
                }
                this.isLoading = false;
            })
        },
        dateFilterApplied(dateFromTimestamp, dateToTimestamp, type) {
            this.dates.start = dateFromTimestamp;
            this.dates.end = dateToTimestamp;
        },
    }
}
</script>

<style scoped lang="scss">
    @import "../../../../../sass/admin-panel/partials/_loader.scss";
    .set-price {
        width: 10em;
        margin-bottom: 1em;
    }
    .set-price-header {
        text-align: center;
        padding-top: 1em;
        padding-bottom: 1em;
    }
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-log-owner-report/CreateTrafficOwnerReport.vue